/* eslint-disable camelcase */
import {
    SET_SURGERY_DETAILS,
    SET_CART_DATA,
    UPDATE_CART_DATA,
    UPDATE_CART_DATA_SHIPPING,
    SET_SHIPPING_DETAILS,
    HANDLE_SURGERY_NOTES,
    SET_PRICING_NOTES,
    SET_VISUALIZATION_INSPECTION,
    RESET_SURGERY_DETAILS,
    CHANGE_SHIPPING_SEGMENT_INDEX,
    SET_SHIPPING_DETAILS_EDIT_MODE,
    CHANGE_SHIPPING_ACKNOWLEGMENT_CHECKOUT,
    DISABLE_SURGERY_DATE,
    CURRENT_SURGERY_DATE_SELECTED,
    CHANGE_ACKNOWLEGMENT_VIEW,
    SET_SCHEDULE_SURGERY_CU_IN_PROGRESS,
    PUT_RECENTLY_USED_PHYSICIANS,
    PUT_RECENTLY_USED_PHYSICIANS_SUCCESS,
    PUT_RECENTLY_USED_PHYSICIANS_FAILURE,
    GET_DERIVED_TERRITORIES,
    SET_DERIVED_TERRITORIES_SUCCESS,
    SET_DERIVED_TERRITORIES_FAILURE,
    GET_HOLIDAY_LIST_SUCCESS,
} from '../actions';
// import { DropdownOption } from 'src/constants/templateConstants';
import { TISSUE_AND_NON_TISSUE_SALES_ORG } from 'src/constants/productConstants';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web
import { generate_UUID } from 'src/utils/util';
//import { SetTransform } from 'src/utils/util';

const updateCartProducts = (products, { operation, productKey, isSet }) => {
    const clonedProducts = [...products];
    const index = clonedProducts.findIndex(
        (item) => item.productKey === productKey
    );
    if (operation === 'increment' && isSet) {
        clonedProducts.push({
            ...clonedProducts[index],
            productKey: generate_UUID(),
        });
    } else if (operation === 'decrement' && isSet) {
        clonedProducts.splice(index, 1);
    } else if (operation === 'increment' && !isSet) {
        clonedProducts[index].quantity = clonedProducts[index].quantity + 1;
    } else {
        clonedProducts[index].quantity = clonedProducts[index].quantity - 1;
    }

    return clonedProducts;
};

const updateCartProductsShipping = (products, fieldsToBeAdded, productKeys) => {
    const clonedProducts = [...products];
    for (let i in productKeys) {
        for (let j in clonedProducts) {
            if (productKeys[i] === clonedProducts[j].productKey) {
                clonedProducts[j] = {
                    ...clonedProducts[j],
                    ...fieldsToBeAdded,
                };
                break;
            }
        }
    }

    return clonedProducts;
};

const initialState = {
    formType: 'AddSurgery/ModifySurgery',
    surgeryDetails: {
        districtId: '',
        territoryId: '',
        procedureCode: '',
        accountId: '',
        surgeryDateTime: '',
        surgeryDuration: '',
        physicianId: '',
        caseCoverageId: '',
        hrefId: '',
        patientFirstName: '',
        patientLastName: '',
        patientSalutation: '',
        patientSex: '',
        patientDOB: '',
        patientContactName: '',
        patientContactNumber: '',
        inventoryShipping: false,
        physicianDropDown: '',
        template: '',
        surgeryTimeWithoutEDT: '',
    },
    notes: [],
    pricingNotes: '',
    cartData: {
        products: [],
        templateUId: '',
    },
    shippingDetails: {
        [TISSUE_AND_NON_TISSUE_SALES_ORG.tissue]: {
            attention: '',
            salesOrg: TISSUE_AND_NON_TISSUE_SALES_ORG.tissue,
            shippingAddressId: '',
            shippingMethodId: '',
            userAcknowledgement: false,
        },
        [TISSUE_AND_NON_TISSUE_SALES_ORG.nonTissue]: {
            attention: '',
            salesOrg: TISSUE_AND_NON_TISSUE_SALES_ORG.nonTissue,
            shippingAddressId: '',
            shippingMethodId: '',
            userAcknowledgement: false,
        },
    },
    derivedTerritoryDetails: {},
    derivedTerritoryLoading: false,
    derivedTerritoryStatusCode: 0,
    derivedTerritoryStatusMessage: '',
    visualInspectionAcknowledgement: false,
    surgeryLoading: false,
    surgeryError: false,
    selectedShippingSegment: 0, // Selected segment of shipping section
    tissueAcknowlegmentCheckBox: false, //selected checkbox for shipping section
    nonTissueAcknowlegmentCheckBox: false, //selected checkbox for shipping section
    disableSurgeryDate: false, // disable surgery date of details section for past date
    currentSurgeryDateSelected: false,
    showAcknowlegment: {
        tissue: false,
        nontissue: false,
    },
    surgeryCUInProgress: true,
    recenlyUsedPhysicians: {},
    isHoliday: '',
};

const EquityReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_SURGERY_DETAILS:
            return {
                ...state,
                surgeryDetails: {
                    ...state.surgeryDetails,
                    patientContactName:
                        state.surgeryDetails.patientContactName.trim(),
                    ...action.payload,
                },
            };
        case SET_CART_DATA:
            return {
                ...state,
                cartData: {
                    products: action.payload.products
                        ? [...action.payload.products]
                        : state.cartData.products,
                    templateUId: action.payload.templateUId
                        ? { ...action.payload.templateUId }
                        : action.payload.templateUId == ''
                        ? ''
                        : state.cartData.templateUId,
                },
            };
        case UPDATE_CART_DATA:
            return {
                ...state,
                cartData: {
                    products: updateCartProducts(
                        state.cartData.products,
                        action.payload
                    ),
                },
            };

        case UPDATE_CART_DATA_SHIPPING:
            return {
                ...state,
                cartData: {
                    products: updateCartProductsShipping(
                        state.cartData.products,
                        action.payload.newFields,
                        action.payload.productKeys
                    ),
                },
            };
        case SET_PRICING_NOTES:
            return {
                ...state,
                cartData: {
                    products: state.cartData.products,
                    pricingNotes: action.payload,
                },
            };
        case SET_SHIPPING_DETAILS:
            return {
                ...state,
                shippingDetails: {
                    ...state.shippingDetails,
                    [action.payload.salesOrg]: {
                        ...state.shippingDetails[action.payload.salesOrg],
                        ...action.payload,
                    },
                },
            };
        case SET_SHIPPING_DETAILS_EDIT_MODE:
            return {
                ...state,
                shippingDetails: action.payload,
            };
        case HANDLE_SURGERY_NOTES:
            return {
                ...state,
                notes: action.payload,
            };
        case SET_VISUALIZATION_INSPECTION:
            return {
                ...state,
                visualInspectionAcknowledgement: action.payload,
            };
        case RESET_SURGERY_DETAILS:
            return {
                ...state,
                ...initialState,
            };
        case CHANGE_SHIPPING_SEGMENT_INDEX:
            return {
                ...state,
                selectedShippingSegment: action.payload,
            };
        case CHANGE_ACKNOWLEGMENT_VIEW:
            return {
                ...state,
                showAcknowlegment: {
                    ...state.showAcknowlegment,
                    [action.payload.name]: action.payload.value,
                },
            };
        case CHANGE_SHIPPING_ACKNOWLEGMENT_CHECKOUT:
            return {
                ...state,
                [action.payload.name]: action.payload.value,
            };
        case DISABLE_SURGERY_DATE:
            return {
                ...state,
                disableSurgeryDate: action.payload,
            };
        case CURRENT_SURGERY_DATE_SELECTED:
            return {
                ...state,
                currentSurgeryDateSelected: action.payload,
            };
        case SET_SCHEDULE_SURGERY_CU_IN_PROGRESS:
            return {
                ...state,
                surgeryCUInProgress: action.data,
            };
        case PUT_RECENTLY_USED_PHYSICIANS:
            return {
                ...state,
            };
        case PUT_RECENTLY_USED_PHYSICIANS_SUCCESS:
            return {
                ...state,
                recenlyUsedPhysicians: action.data,
            };
        case PUT_RECENTLY_USED_PHYSICIANS_FAILURE:
            return {
                ...state,
                recenlyUsedPhysicians: action.templateError,
            };
        case GET_DERIVED_TERRITORIES:
            return {
                ...state,
                derivedTerritoryDetails: {},
                derivedTerritoryLoading: true,
            };

        case SET_DERIVED_TERRITORIES_SUCCESS:
            return {
                ...state,
                derivedTerritoryDetails: {
                    ...state.derivedTerritoryDetails,
                    interTerritoryId: action.interTerritoryId,
                    nonInterTerritoryId: action.nonInterTerritoryId,
                    derivedResponse: action.derivedResponse,
                },
                derivedTerritoryStatusCode: action.statusCode,
                derivedTerritoryStatusMessage: action.statusMessage,
                derivedTerritoryLoading: false,
            };

        case SET_DERIVED_TERRITORIES_FAILURE:
            return {
                ...state,
                derivedTerritoryDetails: {},
                derivedTerritoryStatusCode: action.statusCode,
                derivedTerritoryStatusMessage: action.statusMessage,
                derivedTerritoryLoading: false,
            };
        case GET_HOLIDAY_LIST_SUCCESS:
            return {
                ...state,
                isHoliday: action.payload,
            };
        default: {
            return { ...state };
        }
    }
};

export default persistReducer(
    {
        key: 'equityKey',
        storage: storage,
        //transforms: [SetTransform],
    },
    EquityReducer
);
